export const GEOPACKAGE_LIMITS = {
  maximumFileBytes: 512 * 1024 * 1024,
  maximumContents: 500,
  maximumMetadataEntries: 2_000,
  maximumDiscoveryColumns: 512,
  maximumSelectedContents: 24,
  maximumRowsPerContent: 100_000,
  maximumTotalRows: 150_000,
  maximumFieldsPerContent: 128,
  maximumCells: 2_000_000,
  maximumGeometryBytes: 4 * 1024 * 1024,
  maximumDecodedBytes: 128 * 1024 * 1024,
} as const;
